import type { SlugRules } from '~/api/endpoints/clients'

/**
 * The name as a slug — the same suggestion the backend makes when none is given
 * (`suggest_slug`): accents dropped, lowercased, every run of anything else one hyphen.
 */
export function suggestSlug(name: string, maxLength = 63): string {
  return name
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, maxLength)
    .replace(/-+$/, '')
}

/**
 * Why this cannot be a slug, by the rules the backend sent (`slug_rules`), or null. Only
 * a pre-check, so the button greys out before the click: the backend checks again, and
 * says when another client already holds the slug.
 */
export function slugProblem(slug: string, rules: SlugRules | undefined): string | null {
  if (!rules) return null
  if (!slug) return 'A slug is needed.'
  if (!new RegExp(rules.pattern).test(slug)) {
    return `Lowercase letters, digits and hyphens only, 1–${rules.max_length} characters, not starting or ending with a hyphen.`
  }
  if (rules.reserved.includes(slug)) return `“${slug}” is reserved.`
  return null
}

/** The default client's slug: where anything created with no client named lands. */
export const DEFAULT_CLIENT_SLUG = 'voncollective'
